export const IJR = 2020
export const AJR = 2021
